export default __webpack_public_path__ + "static/media/convertise-horizontal.6de5f40d.svg";